export const PRODUCT_CODE = {
  CORE: 'CORE',
  ROCA: 'ROCA',
  BOCA: 'BOCA'
};
